import React from 'react';
import { Icon, ListItemText } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import IntlMessages from '@projectK/helpers/IntlMessages';
import VerticalNavItem from '../VerticalItem/VerticalNavItem';
import AppBadge from '../../../../AppBadge';
import { allowMultiLanguage } from '@projectK/constants/AppConst';

const VerticalAction = ({ level, item }) => {
  return (
    <VerticalNavItem
      level={level}
      button
      onClick={item.action} // 👈 use action here
      id={item.id}
    >
      {item.icon && (
        <Box component='span'>
          <Icon
            sx={{
              fontSize: 18,
              display: 'block',
              mr: 4,
            }}
            className={clsx('nav-item-icon', 'material-icons-outlined')}
            color='action'
          >
            {item.icon}
          </Icon>
        </Box>
      )}
      <ListItemText
        className='nav-item-content'
        primary={
          allowMultiLanguage ? <IntlMessages id={item.messageId} /> : item.title
        }
        classes={{ primary: 'nav-item-text' }}
      />
      {item.count && (
        <Box sx={{ mr: 3.5 }} className='menu-badge'>
          <AppBadge count={item.count} color={item.color} />
        </Box>
      )}
    </VerticalNavItem>
  );
};

VerticalAction.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    exact: PropTypes.bool,
    messageId: PropTypes.string,
    count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    color: PropTypes.string,
    action: PropTypes.func.isRequired, // 👈 action required
  }),
  level: PropTypes.number,
};

export default React.memo(VerticalAction);
